export type FlowState = { id: string; label: string; text: string; effect: string; branch?: boolean }
export type Flow = { id: string; name: string; states: FlowState[] }

/** Estados documentados en el manual 2.11. Las ramas (branch) son alternativas, no pasos obligatorios. */
export const flows: Flow[] = [
  {
    id: 'recarga',
    name: 'Donación',
    states: [
      { id: 'creada', label: 'Pago por procesar · Orden creada', text: 'Generaste la nota de pago; todavía falta transferir y reportar el identificador.', effect: 'Sin saldo' },
      { id: 'reportado', label: 'Pago por procesar · Pago reportado', text: 'Tu ID de transferencia o TXID y el comentario quedaron ligados a la orden.', effect: 'Sin saldo' },
      { id: 'procesado', label: 'Pago procesado', text: 'La administración vinculó una transferencia; falta la verificación. Procesado no significa acreditado.', effect: 'Sin saldo' },
      { id: 'verificado', label: 'Pago verificado', text: 'El administrador autorizó los créditos por el importe de la orden.', effect: 'Acredita saldo' },
      { id: 'correccion', label: 'Requiere corrección', text: 'La revisión encontró datos por corregir. Corrige el reporte en la misma orden; no vuelvas a pagar.', effect: 'Sin saldo', branch: true },
    ],
  },
  {
    id: 'compra',
    name: 'Compra y entrega',
    states: [
      { id: 'confirmada', label: 'Compra confirmada', text: 'Se registró el cobro y los productos en Mis compras.', effect: 'Créditos cobrados' },
      { id: 'resguardado', label: 'Resguardado', text: 'El ítem continúa en custodia del Market. Envíalo al Gremory cuando la entrega esté disponible.', effect: 'En el Market' },
      { id: 'gremory', label: 'Enviado al Gremory', text: 'Llegó al depósito del juego. Falta retirarlo a la mochila desde Gremory → Cuenta.', effect: 'En el Gremory' },
      { id: 'entregado', label: 'Entregado al juego', text: 'El registro indica que el objeto salió del resguardo hacia el juego.', effect: 'En el juego' },
      { id: 'aplicado', label: 'Aplicado', text: 'El VIP o buff se aplicó a la cuenta o al personaje elegido. No aparece como objeto en la mochila.', effect: 'Beneficio activo', branch: true },
      { id: 'pendiente', label: 'Entrega pendiente', text: 'Si un beneficio permanece así, consulta al staff con el número de compra. No compres de nuevo.', effect: 'Revisar con el staff', branch: true },
    ],
  },
  {
    id: 'retiro',
    name: 'Retiro',
    states: [
      { id: 'pendiente', label: 'Pendiente', text: 'La solicitud se recibió. Los créditos están reservados.', effect: 'Créditos reservados' },
      { id: 'proceso', label: 'En proceso', text: 'La administración está tramitando el envío. La reserva continúa.', effect: 'Créditos reservados' },
      { id: 'pagado', label: 'Pagado', text: 'Se registró el envío manual; puedes consultar el ID de la transferencia.', effect: 'Salida confirmada' },
      { id: 'rechazado', label: 'Rechazado', text: 'La reserva se libera. El plazo de 72 horas entre solicitudes sigue vigente.', effect: 'Reserva liberada', branch: true },
    ],
  },
]
